import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

const TitleWrapperStyle = styled.div`
    label: TitleWrapper;

    font-family: Helvetica, sans-serif;
    font-weight: bold;

    ${({ title_theme }) => {
        if (title_theme === "blue") {
            return `
                color: #0098DB;
            `;
        }
        if (title_theme === "black") {
            return `
                color: #262626;
            `;
        }
        if (title_theme === "white") {
            return `
                color: #ffffff;
            `;
        }
    }};

    ${({ title_align }) => {
        if (title_align === "left") {
            return `
                    text-align: left;
                  `;
        }
        if (title_align === "center") {
            return `
                      text-align: center;
                `;
        }
        if (title_align === "right") {
            return `
                      text-align: right;
                `;
        }
    }};
    ${({ title_type }) => {
        if (title_type === "page-title") {
            return `
                font-size: 56px;
                letter-spacing: 0.25px;
                line-height: 64px;
              `;
        }
        if (title_type === "section-title") {
            return `
                font-size: 40px;
                letter-spacing: 0.25px;
                line-height: 48px;
            `;
        }
        if (title_type === "sub-title") {
            return `
                font-size: 16px;
                letter-spacing: 0;
                line-height: 32px;
            `;
        }
    }};
`;
const TitleWrapper = (props) => <TitleWrapperStyle {...props} />;

export const TitleWrapperPropTypes = {
    title: PropTypes.string,
    title_align: PropTypes.oneOf(["left", "center", "right"]),
    title_theme: PropTypes.oneOf(["blue", "black", "white"]),
    title_type: PropTypes.oneOf(["page-title", "section-title", "sub-title"])
};
TitleWrapper.defaultProps = {
    title_align: "center",
    title_theme: "black",
    title_type: "section-title"
};
TitleWrapper.propsTypes = TitleWrapperPropTypes;
export default TitleWrapper;

// ${({ pageTitle }) =>
//     pageTitle
//         ? `
//             margin-block-start: 0.5em;
//             margin-block-end: 0.3em;
//             font-size: 4rem;
//             line-height: 64px;
//             letter-spacing: -0.37p;
//       `
//         : `
//             margin-block-start: 0.3em;
//             margin-block-end: 0.15em;
//             font-size: 3rem;
//             line-height: 68px;
//             letter-spacing: 0.2px;
//     `};
// //Mobile-landscape (and larger)
// @media (min-width: 320px) {
//     ${({ pageTitle }) =>
// pageTitle
//     ? `
//                           font-size: 3rem;
//                           line-height: 48px;
//                           letter-spacing: -0.37p;
//                       `
//     : `
//                           font-size: 2rem;
//                           line-height: 36px;
//                           letter-spacing: 0.2px;
//                     `};
// }
// //Mobile-landscape (and larger)
// @media (min-width: 480px) {
//     ${({ title_align }) => (title_align ? `text-align: ${title_align};` : "text-align: center;")}
// ${({ pageTitle }) =>
// pageTitle
//     ? `
//                           font-size: 3rem;
//                           line-height: 48px;
//                           letter-spacing: -0.37p;
//                       `
//     : `
//                           font-size: 2rem;
//                           line-height: 36px;
//                           letter-spacing: 0.2px;
//                     `};
// }
// // Tablet-portrait (and larger)
// @media (min-width: 768px) {
//     ${({ title_align }) => (title_align ? `text-align: ${title_align};` : "text-align: center;")}
// ${({ pageTitle }) =>
// pageTitle
//     ? `
//                           font-size: 3rem;
//                           line-height: 48px;
//                           letter-spacing: -0.37p;
//                       `
//     : `
//                           font-size: 2rem;
//                           line-height: 36px;
//                           letter-spacing: 0.2px;
//                     `};
// }
// // Tablet-landscape (and larger)
// @media (min-width: 992px) {
//     ${({ title_align }) => (title_align ? `text-align: ${title_align};` : "text-align: center;")}
// ${({ pageTitle }) =>
// pageTitle
//     ? `
//                 margin-block-start: 0.5em;
//                 margin-block-end: 0.3em;
//                 font-size: 4rem;
//                 line-height: 64px;
//                 letter-spacing: -0.37p;
//               `
//     : `
//                 margin-block-start: 0.5em;
//                 margin-block-end: 0.3em;
//                 font-size: 3rem;
//                 line-height: 68px;
//                 letter-spacing: 0.2px;
//             `};
// }
// // Laptops (and longer)
// @media (min-width: 1200px) {
//     ${({ title_align }) => (title_align ? `text-align: ${title_align};` : "text-align: left;")}
// ${({ title_type }) => {
//     if (title_type === "page-title") {
//         return `
//                         margin-block-start: 0.5em;
//                         margin-block-end: 0.3em;
//                         font-size: 4rem;
//                         line-height: 64px;
//                         letter-spacing: -0.37p;
//                     `;
//     }
//     if (title_type === "section-title") {
//         return `
//                         margin-block-start: 0.3em;
//                         margin-block-end: 0.15em;
//                         font-size: 3rem;
//                         line-height: 68px;
//                         letter-spacing: 0.2px;
//                     `;
//     }
//     if (title_type === "sub-title") {
//         return `
//                               font-size: 2rem;
//                               line-height: 48px;
//                               letter-spacing: 0.2px;
//                         `;
//     }
// }};
// }
